import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	ActionSheetController,
	NavController,
	NavParams,
	Platform,
	LoadingController,
	App,
	ModalController
} from 'ionic-angular';
import { TapticEngine } from '@ionic-native/taptic-engine';
import { MySportProfileListItem, UserProvider, PublicProfileModel } from '../../../../providers/user/user';
import { SessionProvider } from '../../../../providers/session/session';
import { ResultProfilePage } from '../../../results/result-profile/result-profile';
import { ValueProvider } from '../../../../providers/value/value';
import { ParticipantListComponent } from '../../../../components/participant-list/participant-list';
import { EventProvider } from '../../../../providers/event/event';
import { ActivityFriendsPage, FeedResponse } from '../../../event/event-activity-tabs/activity-friends/activity-friends';
import { ExternalFeedsPage } from '../../../event/event-activity-tabs/external-feeds-page/external-feeds-page';
/**
 * Generated class for the MysportTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: 'page-mysport-contacts',
	templateUrl: 'mysport-contacts.html'
})
export class MysportContactsPage {
	mysportpage: string = 'friends';
	friendList: MySportProfileListItem[];
	feeds: FeedResponse[]=[]
	paginator = {
		page: null,
		start: null,
		limit: null
		}

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private actionSCtrl: ActionSheetController,
		public translate: TranslateService,
		private taptic: TapticEngine,
		private platform: Platform,
		private userService: UserProvider,
		private loadingCtrl: LoadingController,
		private valueService: ValueProvider,
		private app: App,
		private modalCtrl: ModalController,
		private eventService: EventProvider,
		private sessionService: SessionProvider
	) {
		this.friendList = navParams.data.friendList;
		console.log('friendList: ', this.friendList);

		if (navParams.data.page) {
			this.mysportpage = navParams.data.page;
		}
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad MysportTabsPage');
	}

	onDeleteFriend(id) {
		this.userService.removeFriend(id).then((status) => {
			this.removeFriend(id);
		});
	}

	onParticipantList() {
		// this.eventService.searchRouteParticipant(this.sessionService.profile.forName).then((pList) => {
		// 	console.log('results: ', pList);
		let modal = this.modalCtrl.create(ParticipantListComponent);
		modal.present();

		modal.onDidDismiss((patricipant) => {
			if (patricipant) this.addFriend(patricipant);
		});
		// })
	}

	addFriend(patricipant) {
		var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
		loader.present();
		this.userService.addFriend(patricipant.lid).then(friendList => {
			console.log('friendList: ', friendList);
			// this.userService.getMyFriends().then((friendList: MySportProfileListItem[]) => {
			this.friendList = friendList;
			loader.dismiss()
			// });
		});
	}

	onFriendPressed(profile) {
		let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
		// loader.present();
		let userLid = profile.lid
		this.eventService.getFeeds(this.paginator,userLid).then((feeds) => {
		this.feeds = feeds;
		this.navCtrl.push(ExternalFeedsPage, { feeds: feeds})
    })	
		console.log('profile', profile)
	}

	remove(id: number) {
		let sheet = this.actionSCtrl.create({
			title: this.translate.instant('MYSPORT_CONTACT_DELETE_QUESTION'),
			buttons: [
				{
					text: this.translate.instant('GLOBAL_DELETE'),
					role: 'destructive',
					handler: () => {
						this.removeFriend(id);
					}
				},
				{
					text: this.translate.instant('GLOBAL_CANCEL'),
					role: 'cancel'
				}
			]
		});

		if (window['TapticEngine'] && this.platform.is('ios')) {
			this.taptic.selection();
		}
		sheet.present();
	}

	removeFriend(id: number) {
		this.friendList = this.friendList.filter((x: any) => x.lid != id);
	}
}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-contacts/mysport-contacts.ts